export const sortingOptions = {
  'nft-market-nftexplorer-assets': [
    { value: 'transferred', label: 'Transferred (Newest)' },
    { value: 'transferred-desc', label: 'Transferred (Oldest)' },
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'minted-asc', label: 'Mint (Highest)' },
    { value: 'minted-desc', label: 'Mint (Lowest)' },
  ],
  'nft-market-nftexplorer-collections': [
    { value: 'popularity', label: 'Popularity' },
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'collection_name-asc', label: 'Alphabetical (A-Z)' },
    { value: 'collection_name-desc', label: 'Alphabetical (Z-A)' }
  ],
  'nft-market-nftexplorer-templates': [
    { value: 'popularity', label: 'Popularity' },
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'name-asc', label: 'Alphabetical (A-Z)' },
    { value: 'name-desc', label: 'Alphabetical (Z-A)' }
  ],
  'wallet-nfts-inventory': [
    { value: 'transferred', label: 'Transferred (Newest)' },
    { value: 'transferred-desc', label: 'Transferred (Oldest)' },
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'minted-asc', label: 'Mint (Highest)' },
    { value: 'minted-desc', label: 'Mint (Lowest)' },
    { value: 'name-asc', label: 'Alphabetical (A-Z)' }
  ],
  'wallet-nfts-listings': [
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'updated-asc', label: 'Mint (Highest)' },
    { value: 'updated-desc', label: 'Mint (Lowest)' },
    { value: 'price-asc', label: 'Price (Increasing)' },
    { value: 'price-desc', label: 'Price (Decreasing)' }
  ],
  'wallet-nfts-auctions': [
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'updated-asc', label: 'Mint (Highest)' },
    { value: 'updated-desc', label: 'Mint (Lowest)' },
    { value: 'ending-asc', label: 'End Date (Highest)' },
    { value: 'ending-desc', label: 'End Date (Lowest)' },
    { value: 'price-asc', label: 'Price (Increasing)' },
    { value: 'price-desc', label: 'Price (Decreasing)' }
  ],
  'wallet-nfts-bought': [
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'updated-asc', label: 'Mint (Highest)' },
    { value: 'updated-desc', label: 'Mint (Lowest)' },
    { value: 'price-asc', label: 'Price (Increasing)' },
    { value: 'price-desc', label: 'Price (Decreasing)' }
  ],
  'wallet-nfts-sold': [
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'updated-asc', label: 'Mint (Highest)' },
    { value: 'updated-desc', label: 'Mint (Lowest)' },
    { value: 'price-asc', label: 'Price (Increasing)' },
    { value: 'price-desc', label: 'Price (Decreasing)' }
  ],
  'account-id-nfts-inventory': [
    { value: 'transferred', label: 'Transferred (Newest)' },
    { value: 'transferred-desc', label: 'Transferred (Oldest)' },
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'minted-asc', label: 'Mint (Highest)' },
    { value: 'minted-desc', label: 'Mint (Lowest)' },
    { value: 'name-asc', label: 'Alphabetical (A-Z)' }
  ],
  'account-id-nfts-listings': [
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'updated-asc', label: 'Mint (Highest)' },
    { value: 'updated-desc', label: 'Mint (Lowest)' },
    { value: 'price-asc', label: 'Price (Increasing)' },
    { value: 'price-desc', label: 'Price (Decreasing)' }
  ],
  'account-id-nfts-auctions': [
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'updated-asc', label: 'Mint (Highest)' },
    { value: 'updated-desc', label: 'Mint (Lowest)' },
    { value: 'ending-asc', label: 'End Date (Highest)' },
    { value: 'ending-desc', label: 'End Date (Lowest)' },
    { value: 'price-asc', label: 'Price (Increasing)' },
    { value: 'price-desc', label: 'Price (Decreasing)' }
  ],
  'account-id-nfts-bought': [
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'updated-asc', label: 'Mint (Highest)' },
    { value: 'updated-desc', label: 'Mint (Lowest)' },
    { value: 'price-asc', label: 'Price (Increasing)' },
    { value: 'price-desc', label: 'Price (Decreasing)' }
  ],
  'account-id-nfts-sold': [
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'updated-asc', label: 'Mint (Highest)' },
    { value: 'updated-desc', label: 'Mint (Lowest)' },
    { value: 'price-asc', label: 'Price (Increasing)' },
    { value: 'price-desc', label: 'Price (Decreasing)' }
  ],
  'nft-market-nft-marketplace-sales': [
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'updated-asc', label: 'Updated (Highest)' },
    { value: 'updated-desc', label: 'Updated (Lowest)' },
    { value: 'template_mint-asc', label: 'Mint (Highest)' },
    { value: 'template_mint-desc', label: 'Mint (Lowest)' },
    { value: 'price-asc', label: 'Price (Increasing)' },
    { value: 'price-desc', label: 'Price (Decreasing)' }
  ],
  'nft-market-nft-marketplace-auctions': [
    { value: 'created-asc', label: 'Created (Newest)' },
    { value: 'created-desc', label: 'Created (Oldest)' },
    { value: 'updated-asc', label: 'Updated (Highest)' },
    { value: 'updated-desc', label: 'Updated (Lowest)' },
    { value: 'template_mint-asc', label: 'Mint (Highest)' },
    { value: 'template_mint-desc', label: 'Mint (Lowest)' },
    { value: 'ending-asc', label: 'End Date (Highest)' },
    { value: 'ending-desc', label: 'End Date (Lowest)' },
    { value: 'price-asc', label: 'Price (Increasing)' },
    { value: 'price-desc', label: 'Price (Decreasing)' }
  ]
}
